
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#232227"}},[_c('path',{attrs:{"d":"M5.253 14.775c.192-.036.49-.173.823-.355.906-.494 2.07-1.315 2.07-1.315s6.216-3.79 9.23-9.732c0 0 .384-.967-.548-1.157a1.88 1.88 0 00-.423-.03l-.013-.005a1.615 1.615 0 00-.344-.073c-.339-.036-.854.008-1.261.48L4.688 14.077s-.15.83.565.697z"}}),_c('path',{attrs:{"d":"M6.922 11.805l-3.71-.604-.922 1.078 2.414 1.795s2.42-1.816 2.218-2.27zM12.185 5.671L6.378 7.426l-.65.823 2.9-.27 1.25.561 2.307-2.869zM6.081 14.417c.906-.494 2.07-1.315 2.07-1.315s6.213-3.789 9.227-9.726c0 0 .384-.967-.548-1.157l.004.014s-.46 1.638-4.573 5.864l-6.18 6.32z"}}),_c('path',{attrs:{"d":"M6.825 13.769l-1.477 2.893-.583.327.55-2.36s1.298-1.661 1.51-.86zM16.12 2.956c.103-.076.207-.5.265-.775a1.604 1.604 0 00-.343-.073c-.049.218-.147.586-.267.667-.172.118.19.295.345.181zM10.062 17.36l1.431-.952 1.893-6.698.352-1.243.17-.604c-1.074-.289-3.167 2.85-3.167 2.85-.019.1.02.215.082.327a2.182 2.182 0 00.421.499l-1.182 5.821z"}})])])
          )
        }
      }
    